<!-- Main navbar -->
<!-- <div *ngIf="userLoggedIn && !router.url.includes('login')" class="navbar navbar-inverse"> -->
<div class="navbar navbar-inverse bg-slate-900">
    <div class="navbar-header">
        <ul style="float:left;margin-left:10px;" class="nav navbar-nav">
            <li>
                <a class="sidebar-control sidebar-main-toggle hidden-xs">
                    <i class="icon-paragraph-justify3"></i>
                </a>
            </li>
        </ul>

        <a class="navbar-brand" href="index.html">
            <!-- <img src="img/addispros.png" width="100" height="100" alt="Hulu Tender Admin 1.0"> -->
            <b>Debo Equb Admin 1.0</b>
        </a>

        <ul class="nav navbar-nav pull-right visible-xs-block">
            <li>
                <a data-toggle="collapse" data-target="#navbar-mobile">
                    <i class="icon-tree5"></i>
                </a>
            </li>
            <li>
                <a class="sidebar-mobile-main-toggle">
                    <i class="icon-paragraph-justify3"></i>
                </a>
            </li>
        </ul>
    </div>

    <div class="navbar-collapse collapse" id="navbar-mobile">


        <ul class="nav navbar-nav navbar-right">
            <li>
                <h6>
                    <span id="date">{{todays}}</span>
                </h6>
            </li>
            &nbsp; &nbsp; &nbsp;
            <li class="pull-right">


                <div id="time">
                    <h6>
                        <span id="hours"></span> :
                        <span id="min"></span> :
                        <span id="sec"></span>
                    </h6>
                </div>
            </li>
        </ul>
    </div>
</div>
<!-- /main navbar -->



<!-- Page container -->
<div class="page-container">

    <!-- Page content -->
    <div class="page-content">

        <!-- Main sidebar -->
        <div class="sidebar sidebar-main">
            <!-- <div *ngIf="userLoggedIn && !router.url.includes('login')" class="sidebar sidebar-main"> -->
            <div class="sidebar-content">

                <!-- Main navigation -->
                <div class="sidebar-category sidebar-category-visible">
                    <div class="sidebar-user-material">
                        <div class="category-content">
                            <div class="sidebar-user-material-content">
                                <a href="#">
                                    <img height="200" src="assets/images/ek_logo.png" class="img-circle img-responsive"
                                        alt="User Image">
                                </a>
                                <h6>{{credentials?.username}}</h6>
                                <span class="text-size-small">{{credentials?.email}}</span>
                            </div>

                            <div class="sidebar-user-material-menu">
                                <a href="#user-nav" data-toggle="collapse">
                                    <span>My account</span>
                                    <i class="caret"></i>
                                </a>
                            </div>
                        </div>

                        <div class="navigation-wrapper collapse" id="user-nav">
                            <ul class="navigation">
                                <li>
                                    <a href="#">
                                        <i class="icon-user-plus"></i>
                                        <span>Profile</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <i class="icon-comment-discussion"></i>
                                        <span>
                                            <span class="badge bg-royal-400 pull-right">58</span> Messages</span>
                                    </a>
                                </li>
                                <li class="divider"></li>
                                <li>
                                    <a href="">
                                        <i class="icon-cog5"></i>
                                        <span>Account settings</span>
                                    </a>
                                </li>
                                <li>
                                    <a (click)="signOut()">
                                        <i class="icon-switch2"></i>
                                        <span>Logout</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="category-content no-padding">
                        <ul class="navigation navigation-main navigation-accordion">

                            <!-- Main -->
                            <li class="navigation-header">
                                <span>Main Menu</span>
                                <i class="icon-menu" title="Main pages"></i>
                            </li>
                            <li>
                                <a [routerLink]="['']">
                                    <i class="icon-home4"></i>
                                    <span>Dashboard</span>
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="">
                                    <i class="icon-stack2"></i>
                                    <span>Equb</span>
                                </a>
                                <ul>
                                    <li>
                                        <a [routerLink]="['ekubs']">Equbs</a>
                                    </li>
                                    <li>
                                        <a [routerLink]="['ekubadd']">Add Equb</a>
                                    </li>
                                    <li>
                                        <a [routerLink]="['awards']">Awards</a>
                                    </li>
                                    <li>
                                        <a [routerLink]="['awardadd']">Add Award</a>
                                    </li>
                                    <li>
                                        <a [routerLink]="['draw']">Draw</a>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <a [routerLink]="">
                                    <i class="icon-library2"></i>
                                    <span>Transactions</span>
                                </a>
                                <ul>
                                    <li>
                                        <a [routerLink]="['transactions']">Transactions</a>
                                    </li>
                                    <li>
                                        <a [routerLink]="['sales']">Sales</a>
                                    </li>
                                    <li>
                                        <a [routerLink]="['offers']">Offers</a>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <a href="#">
                                    <i class="icon-grid5"></i>
                                    <span>Categories</span>
                                </a>
                                <ul>
                                    <li>
                                        <a [routerLink]="['categories']">Categories</a>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <a href="#">
                                    <i class="icon-people"></i>
                                    <span>Customers</span>
                                </a>
                                <ul>
                                    <li>
                                        <a [routerLink]="['customers']">Customers</a>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <a href="#">
                                    <i class="icon-files-empty"></i>
                                    <span>Misc</span>
                                </a>
                                <ul>
                                    <li>
                                        <a [routerLink]="['accounts']">Accounts</a>
                                    </li>
                                    <li>
                                        <a [routerLink]="['branches']">Branches</a>
                                    </li>
                                </ul>
                            </li>

                            <!-- Report -->
                            <li class="navigation-header">
                                <span>Reports</span>
                                <i class="icon-menu" title="Reports"></i>
                            </li>
                            <li>
                                <a href="#">
                                    <i class="icon-graph"></i>
                                    <span>Reports</span>
                                </a>
                                <ul>
                                    <li>
                                        <a href="layout_navbar_secondary_fixed.html">Service Report</a>
                                    </li>
                                    <li>
                                        <a href="layout_navbar_main_fixed.html">Financial report</a>
                                    </li>
                                    <li>
                                        <a href="layout_navbar_main_hideable.html">Aggregate Report</a>
                                    </li>
                                </ul>
                            </li>

                            <li>
                                <a href="#">
                                    <i class="icon-brain"></i>
                                    <span>Analytics</span>
                                </a>
                                <ul>
                                    <li>
                                        <a [routerLink]="['ekubsAnalytics']">Equbs Analytics</a>
                                    </li>
                                    <li>
                                        <a [routerLink]="['simulator']">Simulator</a>
                                    </li>
                                    <li>
                                        <a [routerLink]="['preferences']">Preference Analytics</a>
                                    </li>
                                </ul>
                            </li>

                            <!-- /report -->

                            <!-- Ad -->
                            <li class="navigation-header">
                                <span>Ads</span>
                                <i class="icon-menu" title="Ads"></i>
                            </li>
                            <li>
                                <a href="#">
                                    <i class="icon-cube"></i>
                                    <span>Ads</span>
                                </a>
                                <ul>
                                    <li>
                                        <a [routerLink]="['clients']">Clients</a>
                                    </li>
                                    <li>
                                        <a [routerLink]="['ads']">Ads</a>
                                    </li>
                                </ul>
                            </li>

                            <!-- Administration -->
                            <li class="navigation-header">
                                <span>Administration</span>
                                <i class="icon-menu" title="Page kits"></i>
                            </li>
                            <li>
                                <a href="">
                                    <i class="icon-grid6"></i>
                                    <span>Administration</span>
                                </a>
                                <ul>
                                    <li>
                                        <a [routerLink]="['admins']">Admin</a>
                                    </li>
                                    <li>
                                        <a [routerLink]="['/users']">User Management</a>
                                    </li>
                                    <li>
                                        <a [routerLink]="['/notifications']">Notifications</a>
                                    </li>
                                    <li>
                                        <a [routerLink]="['/comments']">Comments</a>
                                    </li>

                                </ul>
                            </li>

                            <li>
                                <a href="">
                                    <i class="icon-eye"></i>
                                    <span>Monitoring</span>
                                </a>
                                <ul>
                                    <li>
                                        <a [routerLink]="['/activities']">Activities</a>
                                    </li>
                                    <li>
                                        <a [routerLink]="['/flags']">Flags</a>
                                    </li>
                                </ul>
                            </li>
                            <!-- /Administration -->

                        </ul>
                    </div>
                </div>
                <!-- /main navigation -->

            </div>
        </div>
        <!-- /main sidebar -->

        <!-- Main content -->
        <div class="content-wrapper">
            <!-- Page header -->
            <div *ngIf="userLoggedIn && !router.url.includes('login')" class="page-header">
                <div class="breadcrumb-line">
                    <ul class="breadcrumb">
                        <li>
                            <a href="index.html">
                                <i class="icon-home2 position-left"></i> Home</a>
                        </li>
                        <li>
                            <a [routerLink]="['tender']">Tenders</a>
                        </li>
                        <li class="active">
                            <a [routerLink]="['news']">News</a>
                        </li>
                    </ul>
                    <ul class="breadcrumb-elements">
                        <li>
                            <a href="">
                                <i class="icon-comment-discussion position-left"></i> Support</a>
                        </li>
                        <li class="dropdown">
                            <a href="" class="dropdown-toggle" data-toggle="dropdown">
                                <i class="icon-gear position-left"></i>
                                Settings
                                <span class="caret"></span>
                            </a>

                            <ul class="dropdown-menu dropdown-menu-right">
                                <li>
                                    <a href="#">
                                        <i class="icon-user-lock"></i> Account security</a>
                                </li>
                                <li>
                                    <a href="#">
                                        <i class="icon-statistics"></i> Analytics</a>
                                </li>
                                <li>
                                    <a href="#">
                                        <i class="icon-accessibility"></i> Accessibility</a>
                                </li>
                                <li class="divider"></li>
                                <li>
                                    <a href="">
                                        <i class="icon-gear"></i> All settings</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>

            </div>
            <!-- /page header -->

            <router-outlet></router-outlet>

        </div>
        <!-- /main content -->

    </div>
    <!-- /page content -->

</div>
<!-- /page container -->